import { ContentBlock, Stack } from 'braid-design-system';

import { AnalyticsProvider } from '../../context/AnalyticsProvider';
import { FeaturesProvider } from '../../context/FeatureProvider';
import { MaintenanceProvider } from '../../context/MaintenanceProvider';
import { PaymentsProvider } from '../../context/PaymentsProvider';
import { StripeProvider } from '../../context/StripeProvider';
import type { PaymentsForAdBudgetProps } from '../../library';
import CajaUseCase from '../../usecases/CajaUseCase';
import { checkAdvNationMapping } from '../../utils/mapCurrencyNation';

import SeekJobsAU from './AU';
import SeekJobsHK from './HK';
import SeekJobsID from './ID';
import SeekJobsMY from './MY';
import SeekJobsNz from './NZ';
import SeekJobsPH from './PH';
import SeekJobsSG from './SG';
import SeekJobsTH from './TH';

const renderView = (
  advertiserNation: string | undefined,
  currency: string | undefined,
) => {
  const country = checkAdvNationMapping(advertiserNation, currency);

  switch (country) {
    case 'AU':
      return <SeekJobsAU />;
    case 'HK':
      return <SeekJobsHK />;
    case 'ID':
      return <SeekJobsID />;
    case 'MY':
      return <SeekJobsMY />;
    case 'NZ':
      return <SeekJobsNz />;
    case 'SG':
      return <SeekJobsSG />;
    case 'PH':
      return <SeekJobsPH />;
    case 'TH':
      return <SeekJobsTH />;
    default:
      return <SeekJobsAU />;
  }
};

export const AdBudgetView = (appProps: PaymentsForAdBudgetProps) => {
  const { advertiserNation, currency, env } = appProps;
  const country = checkAdvNationMapping(advertiserNation, currency);

  return (
    <AnalyticsProvider
      useCase="ADBUDGET"
      trackingAdapter={appProps.trackingAdapter}
    >
      <FeaturesProvider country={country}>
        <MaintenanceProvider country={country}>
          <StripeProvider advertiserNation={country} env={env}>
            <CajaUseCase {...appProps}>
              {(cajaUseCase) => (
                <PaymentsProvider {...cajaUseCase}>
                  <ContentBlock width="large">
                    <Stack space="large">
                      {renderView(advertiserNation, currency)}
                    </Stack>
                  </ContentBlock>
                </PaymentsProvider>
              )}
            </CajaUseCase>
          </StripeProvider>
        </MaintenanceProvider>
      </FeaturesProvider>
    </AnalyticsProvider>
  );
};
